Object.defineProperty(exports, "__esModule", { value: true });
exports.InputFieldNullable = exports.InputField = exports.InputFieldError = exports.compileInputFieldConfig = exports.compileAllInputFields = exports.inputFieldsRegistry = void 0;
const registry_1 = require("./registry");
var registry_2 = require("./registry");
Object.defineProperty(exports, "inputFieldsRegistry", { enumerable: true, get: function () { return registry_2.inputFieldsRegistry; } });
var index_1 = require("./compiler/index");
Object.defineProperty(exports, "compileAllInputFields", { enumerable: true, get: function () { return index_1.compileAllInputFields; } });
Object.defineProperty(exports, "compileInputFieldConfig", { enumerable: true, get: function () { return index_1.compileInputFieldConfig; } });
var error_1 = require("./error");
Object.defineProperty(exports, "InputFieldError", { enumerable: true, get: function () { return error_1.InputFieldError; } });
function InputField(options) {
    return (targetInstance, fieldName) => {
        if (options &&
            options.hasOwnProperty('type') &&
            options.type === undefined) {
            console.log('This can happens when a circular dependency is present. Wrap your explicit type in an arrow function to avoid this problem.');
            throw new TypeError(`InputField "${fieldName}" explicit type is "undefined" on InputObjectType ${targetInstance.constructor}`);
        }
        const finalConfig = {
            property: fieldName,
            name: fieldName,
            ...options
        };
        registry_1.inputFieldsRegistry.set(targetInstance.constructor, fieldName, finalConfig);
    };
}
exports.InputField = InputField;
/**
 * a shorthand for @InputField({isNullable: true})
 */
function InputFieldNullable(options) {
    return InputField({ ...options, isNullable: true });
}
exports.InputFieldNullable = InputFieldNullable;
//# sourceMappingURL=InputFieldDecorators.js.map